export function mergeGrammarSection(targetSection, nativeSection) {
  if (!nativeSection) return targetSection;

  const nativePatterns = nativeSection.patterns || [];
  const nativeMistakes = nativeSection.commonMistakes || [];
  const nativeExamples = Object.fromEntries(
    (nativeSection.examples || []).map((example) => [example.id, example]),
  );

  return {
    ...targetSection,
    concept: nativeSection.concept || targetSection.concept,
    learningObjectives:
      nativeSection.learningObjectives?.length > 0
        ? nativeSection.learningObjectives
        : targetSection.learningObjectives,
    patterns: (targetSection.patterns || []).map((pattern, index) => ({
      ...pattern,
      label: nativePatterns[index]?.label || pattern.label,
    })),
    commonMistakes: (targetSection.commonMistakes || []).map((mistake, index) => ({
      ...mistake,
      explanation: nativeMistakes[index]?.explanation || mistake.explanation,
    })),
    examples: (targetSection.examples || []).map((example) => ({
      ...example,
      translationHint:
        nativeExamples[example.id]?.translationHint || example.translationHint,
    })),
  };
}
